import axios from "axios";

export default axios.create({
  baseURL: `https://api.leblr.fr/api/v1`,
  headers: {
    "Content-type": "application/json",
  },
});
